import { useContext, useEffect, useState } from 'react';

import { OptimizelyContext, OptimizelyDecideOption } from '@optimizely/react-sdk';

import { UserContext } from 'Context/user';

type UseClientSideDPSellerIdExperimentOptions = {
  onDecision?: () => void;
  triggerDecision?: boolean;
};

const DISABLE_DECISION = [OptimizelyDecideOption.DISABLE_DECISION_EVENT];

export const useClientSideDPSellerIdExperiment = (
  flag: string,
  triggerExperiment = false,
  options: UseClientSideDPSellerIdExperimentOptions = {},
) => {
  const [decision, setDecision] = useState(false);
  const { optimizely } = useContext(OptimizelyContext);
  const { userState: user } = useContext(UserContext);
  const userDPSellerId = user?.dpSellerId;
  const { onDecision, triggerDecision } = options || {};

  useEffect(() => {
    if (!triggerExperiment || !userDPSellerId) {
      return;
    }

    optimizely?.onReady().then(() => {
      const result = optimizely.decide(
        flag,
        triggerDecision ? [] : DISABLE_DECISION,
        String(userDPSellerId),
      );
      setDecision(result.enabled && result.variationKey === 'on');
      onDecision?.();
    });
  }, [optimizely, flag, triggerExperiment, userDPSellerId, onDecision, triggerDecision]);

  return decision;
};
